import { render, staticRenderFns } from "./CustomerProjectDetails.vue?vue&type=template&id=3b1a7124&scoped=true"
import script from "./CustomerProjectDetails.vue?vue&type=script&lang=js"
export * from "./CustomerProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerProjectDetails.vue?vue&type=style&index=0&id=3b1a7124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a7124",
  null
  
)

export default component.exports